import React from 'react'
import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";
// Redux
import { connect } from "react-redux";
import { currentTheme } from "../../redux/actions";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);


class LineGraph extends React.Component {
    data = () => {
        return this.props.data;
    }

    options = (theme) => {
        const color = theme === 'dark' ? '#fff' : '#1c1c1c'
        return {
            responsive: true,
            plugins: {
                legend: {
                    labels: {
                        color,
                        boxWidth: 20,
                        boxHeight: 20,
                    },
                    position: 'top',
                    
                }
            },
            scales: {
                y: {
                    grid: {
                        drawBorder: false,
                        color,
                    },
                    ticks: {
                        color,
                    },
                    yAxes: [{
                        ticks: {
                            beginAtZero: true
                        }
                    }],
                },
                x: {
                    grid: {
                        drawBorder: false,
                        color,
                    },
                    ticks: {
                        color,
                    }
                },
            },
        }
    }



    render() {
        return <Line data={this.data()} options={this.options(this.props.theme)} height={this.props.height || null}/>
    }
}

const mapStateToProps = state => {
    return {
        theme: state.theme
    };
};

const mapDispatchToProps = dispatch => {
    return {
        currentTheme: data => dispatch(currentTheme(data))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(LineGraph);